import type { SVGProps } from "react";
export interface HandsHeartIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HandsHeartIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HandsHeartIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M13.957.875c.936 0 1.747.48 2.29 1.102a3.52 3.52 0 0 1 .873 2.408l.002.001c-.037 1.226-.759 2.166-1.42 2.852l-.278.28c-.49.48-.96.924-1.365 1.3l-.98.897a1.615 1.615 0 0 1-2.04.098l-.118-.098a75 75 0 0 1-1.633-1.508l-.715-.689c-.719-.703-1.656-1.73-1.698-3.132l.001-.001a3.53 3.53 0 0 1 .875-2.408C8.294 1.354 9.104.875 10.039.875c.866 0 1.5.308 1.959.688.458-.38 1.093-.688 1.96-.688Zm0 2.25c-.293 0-.459.102-.587.229a1.4 1.4 0 0 0-.202.26l-.157.295v.001l-.028.05-.022.04a1 1 0 0 1-.174.216 1.1 1.1 0 0 1-.299.217 1.1 1.1 0 0 1-.38.103 1.1 1.1 0 0 1-.32-.015 1 1 0 0 1-.157-.038q-.003 0-.005-.002a1 1 0 0 1-.118-.048l-.061-.034-.022-.011a1.1 1.1 0 0 1-.213-.169 1.1 1.1 0 0 1-.178-.221l-.02-.04q-.016-.023-.027-.048l-.002-.001c-.097-.203-.2-.4-.357-.555-.128-.127-.295-.229-.589-.229-.148 0-.377.084-.593.331a1.3 1.3 0 0 0-.32.747l-.002.113v.003l.019.161c.073.38.372.813 1.003 1.43l.693.668c.439.417.84.784 1.159 1.075A74 74 0 0 0 13.85 5.91l.25-.254c.539-.567.761-.969.772-1.337v-.003l-.003-.113a1.3 1.3 0 0 0-.32-.747c-.215-.247-.445-.331-.593-.331Z"
      />
      <path
        fill={color}
        d="M16.88 22v-.217c0-.787.296-1.545.83-2.122l2.135-2.308a3.88 3.88 0 0 0 1.031-2.632l.001-6.094a.502.502 0 0 0-.991-.102l-.01.1-.017 5.207q0 .03-.003.059a2.8 2.8 0 0 1-.653 1.732l-1.336 1.597a1.126 1.126 0 0 1-1.725-1.444l1.335-1.597.062-.09a.56.56 0 0 0-.038-.594l-.073-.08a.555.555 0 0 0-.768.016l-2.69 2.69a2.88 2.88 0 0 0-.842 2.034V22a1.126 1.126 0 0 1-2.25 0v-3.845l-.014-.284a2.88 2.88 0 0 0-.828-1.75l-2.69-2.69a.554.554 0 0 0-.949.394l.01.094a.55.55 0 0 0 .12.26l1.337 1.597A1.125 1.125 0 0 1 6.14 17.22l-1.338-1.596a2.8 2.8 0 0 1-.655-1.792l-.016-5.206v-.001a.502.502 0 0 0-1.003.002l.001 6.094c0 .976.369 1.916 1.032 2.633l2.134 2.307.189.224c.415.543.643 1.21.643 1.898V22a1.126 1.126 0 0 1-2.25 0v-.217a.9.9 0 0 0-.135-.464l-.098-.13-2.136-2.308a6.13 6.13 0 0 1-1.629-4.16L.878 8.627A2.752 2.752 0 0 1 6.38 8.62l.008 2.458a2.8 2.8 0 0 1 2.547.763l2.691 2.69q.2.202.375.421.176-.219.378-.42l2.69-2.691a2.8 2.8 0 0 1 2.547-.763l.008-2.458.015-.282a2.752 2.752 0 0 1 5.487.29l-.001 6.094a6.13 6.13 0 0 1-1.629 4.16l-2.134 2.308a.88.88 0 0 0-.233.594V22a1.125 1.125 0 0 1-2.25 0Z"
      />
    </svg>
  );
}
